export default {
	ADD_CAPACITY(state, item) {
		state.capabilities.push(item);
	},
	SET_CAPACITY(state, capabilities) {
		state.capabilities = capabilities;
	},
	UPDATE_CAPACITY(state, capacity) {
		const capacityIndex = state.capabilities.findIndex((p) => p.id === capacity.id);
		Object.assign(state.capabilities[capacityIndex], capacity);
	},
	REMOVE_CAPACITY(state, itemId) {
		const ItemIndex = state.capabilities.findIndex((p) => p.id === itemId);
		state.capabilities.splice(ItemIndex, 1);
	},
	ADD_ASSIGNED_CAPACITY(state, capacities) {
		const concatArray = capacities.filter(
			(capacity) => !state.listSelectedCapacities.some((stateCapacity) => stateCapacity.id === capacity.id)
		);
		state.listSelectedCapacities = [...concatArray, ...state.listSelectedCapacities];
	},
	SET_ASSIGNED_CAPACITY(state, items) {
		let arrayNew = state.listSelectedCapacities.concat(
			items.filter((element) => state.listSelectedCapacities.find((e) => e.id === element.id) === undefined)
		);
		state.listSelectedCapacities = arrayNew;
	},
	REMOVE_ASSIGNED_CAPACITY(state, id) {
		const itemIndex = state.listSelectedCapacities.findIndex((skill) => skill.id === id);
		state.listSelectedCapacities.splice(itemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_CAPACITY(state) {
		state.listSelectedCapacities = [];
	},
	ADD_CAPACITY_CHECKED(state, item) {
		const itemIndex = state.checkedCapacities.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedCapacities.push(item);
		}
	},
	SET_CAPACITY_CHECKED(state, capacities) {
		state.checkedCapacities = capacities;
	},
	REMOVE_CAPACITY_CHECKED(state, item) {
		const itemIndex = state.checkedCapacities.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedCapacities.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_CAPACITY_CHECKED(state) {
		state.checkedCapacities = [];
	},
	SELECTED_CAPACITY(state, capacity) {
		if (capacity) {
			state.currentCapacityId = capacity.id !== undefined ? capacity.id : 0;
			state.currentCapacity = capacity;
		} else {
			state.currentCapacity = {};
			state.currentCapacityId = 0;
		}
	},
	ADD_ID_CAPACITY(state, id) {
		state.capacityIds.push(id);
	},
	REMOVE_ID_CAPACITY(state, item) {
		const itemIndex = state.capacityIds.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.capacityIds.splice(itemIndex, 1);
		}
	},
};
